import { useState, useEffect, useCallback } from "react";
import GetBroadcasts from "components/getBroadcasts/GetBroadcasts";

import styles from "./Broadcast.module.css";

import Info from "./info/Info";
import { BroadcastObject } from "types/broadcast";
import StatusSelector from "./StatusSelector";
import Filters from "./filters/Filters";
import { FiltersType } from "types/filters";
import { Screens } from "types/general";
import BroadcastWrapper from "./BroadcastWrapper";

interface Props {
	id: string;
	facilityId: string;
	setScreen: (v: Screens) => void;
	setSelectedBroadcastId: (id: string) => void;
}
function Broadcast({ id, setScreen, setSelectedBroadcastId, facilityId }: Props) {
	// const [error, setError] = useState<string>();

	const [tabSelected, setTabSelected] = useState<"streaming" | "scheduled" | "archived">("streaming");

	const [filters, setFilters] = useState<FiltersType>({
		dates: {
			startDate: "",
			endDate: "",
		},
		sports: "",
		searchQuery: "",
	});

	const [isLoading, setIsLoading] = useState(true);
	const [broadcastData, setBroadcastData] = useState<BroadcastObject>();
	const [broadcastId, setBroadcastId] = useState<string>(id);

	const onNewBroadcastSelect = (id: string) => {
		window.scrollTo(0, 0);
		setBroadcastData(undefined);
		setBroadcastId(id);
		setSelectedBroadcastId(id);
	};
	const getBroadcast = useCallback(async () => {
		try {
			const response = await fetch(`https://arbiter.musco.io/pub/broadcast?id=${broadcastId}`);
			const data: BroadcastObject[] = await response.json();

			if (!data.length) throw new Error();

			setBroadcastData(data[0]);
		} catch (reason) {
			// setError("An error occurred. Please try again later.");
		} finally {
			setIsLoading(false);
		}
	}, [broadcastId]);
	useEffect(() => {
		window.scrollTo(0, 0);
		getBroadcast();
	}, [getBroadcast]);
	return (
		<div className={styles.broadcast}>
			<section>
				<button className="btn btn-link text-primary d-flex align-items-center" onClick={() => setScreen("facility")}>
					Back to main page
				</button>
			</section>
			{broadcastData !== undefined && (
				<BroadcastWrapper broadcastData={broadcastData} reload={getBroadcast} setScreen={setScreen} />
			)}
			{broadcastData !== undefined && (
				<Info broadcastData={broadcastData} isLoading={isLoading || broadcastData === null} />
			)}
			<StatusSelector tabSelected={tabSelected} setTabSelected={(v) => setTabSelected(v)} />
			<section>
				<Filters sendFilters={(x: FiltersType) => setFilters(x)} />
			</section>

			<section className={styles.expandableList}>
				<GetBroadcasts
					filters={filters}
					facilityID={facilityId}
					hideTitle
					isLoading={isLoading || !broadcastData}
					viewerStatus={tabSelected}
					selectBroadcast={(id: string) => onNewBroadcastSelect(id)}
				/>
			</section>
		</div>
	);
}

export default Broadcast;
